import { Col, Layout, Row, Typography } from "antd";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import SearchIcon from "../../../assets/icons/search-white.svg";
import Popcorn from "../../../assets/images/popcorn.webp";
import DirectLinksComponent from "../../../components/DirectLinksComponent";
import FanHomeSuggestionComponent from "../../../components/FanHomeSuggestionComponent";
// import FanPhoneModalComponent from "../../../components/FanPhoneModalComponent";
import FooterComponent from "../../../components/FooterComponent";
import MainSwiper from "../../../components/MainSwiper";
import IsSearchingComponent from "../../../components/Search/IsSearchingComponent";
import SearchComponent from "../../../components/Search/SearchComponent";
import { FOOTER_IDS } from "../../../helpers/constant";
import { IUser } from "../../../helpers/types";
import { AppDispatch, StoreState } from "../../../redux/store";
import { authService } from "../../../services";
//import FanDiscoverLiveGiftComponent from "../../../components/FanDiscoverLiveGiftComponent";
import { useDispatch } from "react-redux";
import { resetList } from "../../../redux/users/usersSlice";
import RecentVisitedProfile from "../../CommonPages/RecentVisitedProfile";
import "./index.less";

const FanHomePage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const user: IUser = authService.getUser();
  const { homeFeeds } = useSelector((state: StoreState) => state.feeds);
  const scrollRef = useRef<HTMLDivElement>(null);
  const [searchValue, setSearchValue] = useState("");
  const [isSearching, setIsSearching] = useState<boolean>(false);
  const [showCancelButton, setShowCancelButton] = useState<boolean>(false);
  const [showRecentVisitedProfile, setShowRecentVisitedProfile] = useState(false);
  // const { currentUserSettings } = useFetchUserSettings();
  // const closePhoneModal = () => {
  //   if (!currentUserSettings?.phoneModalShown) {
  //     dispatch(updatePhoneModalShown());
  //   }
  // };

  const handleScroll = () => {
    if (scrollRef.current) {
      localStorage.removeItem("isHome");
      scrollRef.current.scrollIntoView({
        behavior: "smooth",
        inline: "start",
      });
    }
  };

  useEffect(() => {
    const handleStorageChange = () => {
      const isHome = localStorage.getItem("isHome");

      if (isHome === "true") {
        handleScroll();
      }
    };

    window.addEventListener("localStorageChanged", handleStorageChange);

    return () => {
      window.removeEventListener("localStorageChanged", handleStorageChange);
    };
  }, []);

  const handleInputClick = () => {
    setShowRecentVisitedProfile(true);
    setShowCancelButton(true);
  };

  const searchCreators = (value: string) => {
    if (value !== undefined && value !== "") {
      setSearchValue(value);
      setIsSearching(true);
    }
    if (value === "") {
      clearSearch();
    }
  };

  const clearSearch = () => {
    setSearchValue("");
    dispatch(resetList());
    setIsSearching(false);
    setShowRecentVisitedProfile(true);
  };

  const cancelSearching = () => {
    setSearchValue("");
    setIsSearching(false);
    setShowRecentVisitedProfile(false);
    setShowCancelButton(false);
    dispatch(resetList());
  };

  return (
    <Layout>
      <Layout.Content className="gradient-background-black-blue fanHomeContentFeedWrapper no-scroll-horizontal">
        <div ref={scrollRef}>
          {showRecentVisitedProfile ? (
            <div className="fan-home-header-is-searching-wrapper">
              <Col span={showCancelButton ? 20 : 24}>
                <SearchComponent
                  onClick={handleInputClick}
                  placeholder={`${t("search-2")}`}
                  handleChange={(e) => searchCreators(e.target.value)}
                  value={searchValue}
                />
              </Col>
              {showCancelButton && (
                <Col span={4} className="cancel-text-col">
                  <Typography.Text className="cancel-search-button-text" onClick={cancelSearching}>
                    {t("cancel")}
                  </Typography.Text>
                </Col>
              )}
            </div>
          ) : (
            <Row className="header-row" align="middle">
              <Typography.Text className="title-home-fan">
                {t("for-1")} {user.firstName}
              </Typography.Text>
              <img src={Popcorn} width={24} className="popcorn-icon" alt="twizz-popcorn" />
              <div className="fan-home-search-button">
                <img src={SearchIcon} width={22} className="cursor-pointer search-icon" alt="search" onClick={handleInputClick} />
              </div>
            </Row>
          )}
          {isSearching ? (
            <div className="padding-inline-container">
              <IsSearchingComponent isSearching={isSearching} searchValue={searchValue} />
            </div>
          ) : (
            !isSearching &&
            showRecentVisitedProfile && (
              <div>
                <div className="direct-links-wrapper">
                  <DirectLinksComponent />
                </div>
                <div className="padding-inline-container">
                  <RecentVisitedProfile />
                </div>
              </div>
            )
          )}

          {!isSearching && !showRecentVisitedProfile && <MainSwiper />}
          {homeFeeds.length === 0 && <FanHomeSuggestionComponent showSection4={true} />}
        </div>
        {/* {currentUserSettings && !currentUserSettings?.phoneModalShown && (
          <FanPhoneModalComponent
            visible={!currentUserSettings?.phoneModalShown}
            onClose={() => {
              closePhoneModal();
            }}
          />
        )} */}
      </Layout.Content>
      <FooterComponent type="fan" page={FOOTER_IDS.HOME} />
    </Layout>
  );
};

export default FanHomePage;
